<div class="w-full h-full image-crop-upload-container relative">
  <img *ngIf="borderType === 'profile'"
    [src]="imageUrl || 'assets/images/placeholder.png'"
    alt="Profile"
    [ngClass]="imageClass"
    [ngStyle]="{ 'aspect-ratio': aspectRatio }" style="border-radius: 50%;"
  />
  <img *ngIf="borderType === 'cover'"
    [src]="imageUrl || 'assets/images/placeholder.png'"
    alt="Profile"
    [ngClass]="imageClass"
    [ngStyle]="{ 'aspect-ratio': aspectRatio }" style="border-radius: 6px 6px 20px 6px;"
  />
  <button
    *ngIf="borderType === 'cover' || borderType === 'profile'"
    pButton
    type="button"
    icon="pi pi-camera"
    class="camera-btn absolute bottom-0 right-0 w-3rem h-3rem border-circle"
    (click)="openFileDialog()"
    aria-label="Upload photo"
  ></button>
  <!-- Uploader option for Scholarship  -->
  <div class="flex flex-column justify-content-center align-items-center">
      <div class="flex gap-2">
          <!-- PrimeNG basic uploader only used for scholarship uploads -->
        <p-fileUpload
          *ngIf="borderType === 'scholarship'"
          #primeFileUploader
          mode="basic"
          name="files[]"
          accept="image/*"
          fileLimit="1"
          (onSelect)="onPrimeFileSelect($event)"
          [auto]="false"
          chooseLabel="Browse Images"
          styleClass="fileupload basic-uploader"
        ></p-fileUpload>
        <!-- Scholarship thumbnail with hover preview -->
        <div class="flex flex-column align-items-center">
          <ng-container *ngIf="borderType === 'scholarship' && imageUrl">
          <div class="image-thumbnail-container" tabindex="0">
            <img
              [src]="imageUrl"
              alt="Scholarship"
              class="image-thumbnail"
            />
            <div class="image-preview">
              <img
                [src]="imageUrl"
                alt="Large Preview"
                class="image-large"
              />
            </div>
          </div>
          </ng-container>
          <p-button *ngIf="imageUrl" class="font-regular"
              (onClick)="onFileRemoved()" 
              icon="pi pi-times" 
              styleClass="closeIcon" 
              [rounded]="true" 
              appendTo="body"
              pTooltip="Clear image"
              tooltipPosition="top"
            />
        </div>
      </div>
  </div>
  <input
    #fileInput
    type="file"
    accept="image/*"
    class="hidden"
    (change)="onFileSelected($event)"
  />
</div>

<!-- Cropper Modal using p-dialog -->
<p-dialog
  #cropperDialog
  [visible]="!!croppingImageUrl()"
  [modal]="true"
  [header]="'Crop Image'"
  (onHide)="closeCropper()"
  [style]="{ width: '600px', 'max-width': '90vw' }"
  [appendTo]="'body'"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="content">
    <div class="flex flex-column align-items-center gap-3">
      <div class="cropper-container" style="width: 100%; max-height: 400px; overflow: hidden;">
        <img 
          #imageToCrop 
          [src]="croppingImageUrl()" 
          alt="Image to crop" 
          style="max-width: 100%; height: auto; display: block;"
        />
      </div>
    </div>
  </ng-template>
  
  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <button pButton label="Cancel" (click)="closeCropper()" class="cancel"></button>
      <button pButton label="Crop" (click)="cropImage()" class="crop"></button>
    </div>
  </ng-template>
</p-dialog>
